import { Injectable } from "@angular/core";
import { BaseService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-service.component";
import { ItemCategory } from "../catalog/model/item-category.model";
import { ConfigurationService } from "projects/sepidz-web-framework/src/lib/services";
import { take } from "rxjs/operators";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";

@Injectable({
  providedIn: "root",
})
export class PortalService extends BaseService {
  public itemCategoryList: ItemCategory[] = [];
  public baseURL;
  public itemImages;
  public itemCategoryImages;
  constructor(private conf: ConfigurationService) {
    super();
    this.baseURL = conf.baseUrl;
    this.getItemCategories();
    this.getItemImages();
    this.getItemCategoriesImages();
  }

  public getItemCategories(): void {
    const computerName: string = this.storage.getData(ClearableCache.ComputerName);
    this.httpCommonService
      .get("ItemCategory/GetOrderItemCategory" + (computerName ? "?ComputerName=" + computerName : ""))
      .pipe(take(1))
      .subscribe((data: ItemCategory[]) => {
        this.itemCategoryList = data;
      });
  }

  getItemImages(): void {
    this.httpCommonService
      .get("Peripheral/ItemImage")
      .pipe(take(1))
      .subscribe((data: any) => {
        this.itemImages = data;
      });
  }

  getItemCategoriesImages(): void {
    this.httpCommonService
      .get("Peripheral/SelectedItemCategoriesImage")
      .pipe(take(1))
      .subscribe((data) => {
        this.itemCategoryImages = data;
      });
  }
}
